import React, { useEffect, useRef, useState } from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DocumentEditorContainerComponent, Toolbar, ImageFormat, DocumentEditorKeyDownEventArgs  } from '@syncfusion/ej2-react-documenteditor';
import { PdfBitmap, PdfDocument, PdfPageOrientation, PdfPageSettings, PdfSection, SizeF } from '@syncfusion/ej2-pdf-export';
import { IDocumentLoader, saveDocument2Contentum, IDocumentWoutBody, IDocumentRevisions, saveDocument2Service } from './types/document';
import { ToastComponent , ToastUtility, Toast } from '@syncfusion/ej2-react-notifications';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { IResult, IErrorObject } from './types/document';
import { createSpinner, hideSpinner, showSpinner } from '@syncfusion/ej2-popups';
import moment from 'moment';
import AboutDocumentDialog from './about';
import { L10n } from '@syncfusion/ej2-base';
import wordLocale from './locale/word.locale.json';
import config from './../config.json';
import EditDocumentAbortDialog from './editAbort';

const highlightEditableRangesColor : string = '#fff000';
const unhighlightEditableRangesColor : string = '#fff';

DocumentEditorContainerComponent.Inject(Toolbar);

function loadDocument(editorContainer: DocumentEditorContainerComponent | null, documentLoader: IDocumentLoader) {
    if (!editorContainer) {
        hideSpinner(document.body);
        return ;
    };

    editorContainer.documentEditor.documentName = documentLoader.document.name + ' (v' + documentLoader.document.metadata.versionNumber.toString() + ')';
    editorContainer.documentEditor.open(documentLoader.document.body);
    hideSpinner(document.body);
}

function downloadDocument(editorContainer: DocumentEditorContainerComponent | null) : void {
    if (!editorContainer) return ;

    //editorContainer.documentEditor.userColor = unhighlightEditableRangesColor;
    //editorContainer.documentEditor.documentEditorSettings.highlightEditableRanges = false;
    editorContainer.documentEditor.save(editorContainer.documentEditor.documentName, 'Docx');
    //editorContainer.documentEditor.userColor = highlightEditableRangesColor;
}

function exportDocument2PDF(editorContainer: DocumentEditorContainerComponent | null) : void {
    if (!editorContainer) return ;
    
    editorContainer.documentEditor.userColor = unhighlightEditableRangesColor;

    let pdfdocument: PdfDocument = new PdfDocument();
    let count: number = editorContainer.documentEditor.pageCount;
    editorContainer.documentEditor.documentEditorSettings.printDevicePixelRatio = 2;
    let loadedPage = 0;
    for (let i = 1; i <= count; i++) {
        setTimeout(() => {
            let format : ImageFormat = 'image/jpeg' as ImageFormat;
            // Getting pages as image
            let image = editorContainer.documentEditor.exportAsImage(i, format);
            image.onload = function () {
            let imageHeight = parseInt(
                image.style.height.toString().replace('px', '')
            );
            let imageWidth = parseInt(
                image.style.width.toString().replace('px', '')
            );
            let section: PdfSection = pdfdocument.sections.add() as PdfSection;
            let settings: PdfPageSettings = new PdfPageSettings(0);
            if (imageWidth > imageHeight) {
                settings.orientation = PdfPageOrientation.Landscape;
            }
            settings.size = new SizeF(imageWidth, imageHeight);
            (section as PdfSection).setPageSettings(settings);
            let page = section.pages.add();
            let graphics = page.graphics;
            let imageStr = image.src.replace('data:image/jpeg;base64,', '');
            let pdfImage = new PdfBitmap(imageStr);
            graphics.drawImage(pdfImage, 0, 0, imageWidth, imageHeight);
            loadedPage++;
            if (loadedPage == count) {
                // Exporting the document as pdf
                pdfdocument.save(
                (editorContainer.documentEditor.documentName === ''
                    ? 'sample'
                    : editorContainer.documentEditor.documentName) + '.pdf'
                );
                editorContainer.documentEditor.userColor = highlightEditableRangesColor;
            }
            };
        }, 500);
    }
}

interface IWordAppProps {
    enableRTL: boolean;
    documentLoader: IDocumentLoader;
}

function WordApp(props: IWordAppProps) {
    const enableRTL : boolean = props.enableRTL;
    const documentLoader : IDocumentLoader = props.documentLoader;

    //let allowEdit : boolean = documentLoader.document.access.allowEdit;
    //if (documentLoader.document.metadata.isNowCollaborated) allowEdit = false;

    //const serviceUrl : string =  "https://services.syncfusion.com/react/production/api/documenteditor/";
    //const serviceUrl : string = 'https://ej2services.syncfusion.com/production/web-services/api/documenteditor/';
    //const serviceUrl : string = 'http://10.0.250.7:6002/api/documenteditor/';
    //const serviceUrl : string = 'http://10.0.130.8:6001/api/documenteditor/';
    const serviceUrl : string = 'https://document.e-contentum.com/api/documenteditor/';

    let documentEditorContainer : DocumentEditorContainerComponent | null;

    const [ allowEdit, setAllowEdit ] = useState <boolean>(documentLoader.document.metadata.isNowCollaborated ? false : documentLoader.document.access.allowEdit);

    const [ documentName, setDocumentName ] = useState <string>('');
    const [ contentChange, setContentChange ] = useState <boolean>(false);

    /* Check document edit access periodically */

    const abortController = new AbortController();

    React.useEffect(() => {

        if (!allowEdit) return ;
        if (documentLoader.isExternal) return ;

        let loadFormData : any = new FormData();
        loadFormData.append('sid', documentLoader.requestParams.systemId);
        loadFormData.append('id', documentLoader.requestParams.documentId);
        loadFormData.append('vuid', documentLoader.requestParams.versionUid);
        loadFormData.append('uid', documentLoader.requestParams.userId);

        const id = setInterval(() => {
            fetch(config.settings.baseServerUrl + '/client/api/document/edit/hasaccess', {
                method:"POST",
                signal: abortController.signal,
                body: loadFormData
            })
            .then((response: any) => { 
                if (response.status === 200) {
                    return response.json(); 
                } else {
                    //console.log('Error get data, status: ' + response.status + ', text: ' + response.statustext);
                    return null;
                }
            })
            .then((result: any) => { 
                if (!allowEdit) return ;
                if (result) {
                    if (result.success) {
                        if (!result.data) {
                            //console.log('Abort document editing');
                            setAllowEdit(false);
                            abortController.abort(); 
                            EditDocumentAbortDialog('УВАГА!','На жаль ви не можете далі редагувати цей документ оскільки були вилучені права на внесення змін до цього документу.')
                        }
                    }
                }
            })
            .catch((error: any) => { 
                //console.log(`Error get data: ${error}`); 
                abortController.abort(); 
            });

        }, 1000 * 60 * 3)
        return () => {
            clearInterval(id)
        }
        }, [])
                

    /* Check document edit access */


    const onLoadDefault = () : void => {
        if (!documentEditorContainer) return ;

        //console.log('onLoadDefault');
        //try {
            /*
            window.onerror = function (message, source, lineno, colno, error) {
                // Log the error details or send them to a logging service
                console.error('Error:', message);
                console.error('Source:', source);
                console.error('Line Number:', lineno);
                console.error('Column Number:', colno);
                console.error('Error Object:', error);
            
                // Return true to prevent the default browser error handling
                return false;
            };
            */
            //documentEditorContainer.documentEditor.enableCollaborativeEditing = true;

            // Component create event
            documentEditorContainer.documentEditor.created = () => {
            }
        
            // Component key down event
            documentEditorContainer.documentEditor.keyDown = (args: DocumentEditorKeyDownEventArgs) => {
                let keyCode: number = args.event.which || args.event.keyCode;
                let isCtrlKey: boolean = (args.event.ctrlKey || args.event.metaKey) ? true : ((keyCode === 17) ? true : false);
                let isAltKey: boolean = args.event.altKey ? args.event.altKey : ((keyCode === 18) ? true : false);

                if (isCtrlKey && keyCode === 83) {
                    saveDocument(documentEditorContainer,documentLoader);
                    args.isHandled = true;
                    args.event.preventDefault();
                }

                
                if (isCtrlKey && keyCode === 79) {
                    args.isHandled = true;
                    args.event.preventDefault();
                }

            }

            // Content change event
            documentEditorContainer.documentEditor.contentChange = () => {
                // true - автоматически включает Track Changes, false - можно отключить пользователю
                if (allowEdit && documentEditorContainer) {
                    documentEditorContainer.documentEditor.enableTrackChanges = true;
                    documentEditorContainer.documentEditor.showRevisions = true;
                }
                //if (!contentChange) setContentChange(true);
            }
        
            //documentEditorContainer.restrictEditing = false;
            documentEditorContainer.documentEditor.isReadOnly = !allowEdit;
            documentEditorContainer.currentUser = documentLoader.user.name;
            
            documentEditorContainer.documentEditor.enableWordExport = true;
            documentEditorContainer.documentEditor.enableSfdtExport = true;

            //documentEditorContainer.documentEditor.userColor = '#fff000';
            //documentEditorContainer.documentEditor.documentEditorSettings.highlightEditableRanges = false;

            setDocumentName(documentLoader.document.name);
            
            createSpinner({ target: document.body });
            showSpinner(document.body);
            loadDocument(documentEditorContainer, documentLoader);

        //} catch (e) {
        //    console.log(e);
        //}
    }

    async function saveDocument(editorContainer: DocumentEditorContainerComponent | null, documentLoader: IDocumentLoader) : Promise<void> {
        if (!editorContainer) return ;
        
        //console.log(editorContainer.documentEditor.getComments());
        //console.log(editorContainer.documentEditor.revisions.changes);
        
        //editorContainer.documentEditor.documentEditorSettings.highlightEditableRanges = false;
        //editorContainer.documentEditor.userColor = unhighlightEditableRangesColor;

        const comments : [] = editorContainer.documentEditor.getComments() as any;
        const revisions : [] = editorContainer.documentEditor.revisions.changes as any;

        if (!documentLoader.isExternal) {
            const result : IResult = await saveDocument2Contentum({
                    name: documentLoader.document.name,
                    metadata: documentLoader.document.metadata,
                    access: documentLoader.document.access,
                    requestParams: documentLoader.requestParams,
                    user: documentLoader.user
                } as IDocumentWoutBody,
                {
                    enabled: true,
                    comments: comments.length,
                    revisions: revisions.length
                } as IDocumentRevisions,
                await editorContainer.documentEditor.saveAsBlob('Docx')
            );
            //setContentChange(false);
            if (result.success) {
                infoToastMessage('Документ збережено');
            } else {
                errorToastMessage('На жаль, сталася помилка','При збереженні документа сталася помилка виконання операції на сервері',result.error);
            }
        }
        
        if (documentLoader.isExternal) {
            const result : IResult = await saveDocument2Service({
                    name: documentLoader.document.name,
                    metadata: documentLoader.document.metadata,
                    access: documentLoader.document.access,
                    requestParams: documentLoader.requestParams,
                    user: documentLoader.user
                } as IDocumentWoutBody,
                await editorContainer.documentEditor.saveAsBlob('Docx')
            );
            //setContentChange(false);
            if (result.success) {
                infoToastMessage('Документ збережено');
            } else {
                errorToastMessage('На жаль, сталася помилка','При збереженні документа сталася помилка виконання операції на сервері',result.error);
            }
        }

        //editorContainer.documentEditor.documentEditorSettings.highlightEditableRanges = true;
        //editorContainer.documentEditor.userColor = highlightEditableRangesColor;

    }
    
    let toastInstance: ToastComponent;
    function toastCreated(): void {
        if (documentLoader.document.metadata.isBlocked || !allowEdit || documentLoader.document.metadata.isNowCollaborated)
            toastInstance.show();
    }
    
    function infoToastMessage(message: string) : Toast {
        const toastObj : Toast = ToastUtility.show({
            title: message,
            //content: 'Toast shown using utility function with ToastModel',
            timeOut: 3000,
            position: { X: 'Center', Y: 'Top' },
            showCloseButton: false
        },'Information');
        return toastObj;
    }
    
    function errorToastMessage(message: string, content: string, error: IErrorObject) : Toast {

        function detailsClick(msg: string, error: IErrorObject) : void {
            DialogUtility.alert({
                animationSettings: { effect: 'Zoom' },
                closeOnEscape: true,
                content: '<p>' + msg + '</p><ul><li>' + error.message + '</li>' + '<li>' + error.details as string + '</li></ul>',
                showCloseIcon: true,
                title: 'Інформація щодо помилки'
            });
        }

        const toastObj : Toast = ToastUtility.show({
            title: message,
            content: content,
            timeOut: 5000,
            position: { X: 'Center', Y: 'Top' },
            buttons:  [{
                model: { content: 'Деталі помилки' }, click: () => detailsClick(content,error)
            }]
        });

        return toastObj;
    }

    function getToastContent() : string {
        if (documentLoader.document.metadata.isBlocked)
            return "Цю версію документа було заблоковано користувачем" + ' ' + moment(new Date(documentLoader.document.metadata.blockedDate)).format('DD.MM.YYYY HH:mm');
        if (documentLoader.document.metadata.isNowCollaborated)
            return 'Ви не маєте права редагувати цей документ оскільки він знаходиться в режимі сумісного редагування';
        if (!allowEdit)
            return 'У вас відсутні права на редагування документа. Зверніться будь ласка до автора документа або до адміністратора системи Contentum';
        return '';
    }
      
    L10n.load(wordLocale);

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px' }}>
                <div className="col-md-12">
                <AppBarComponent mode="Dense" colorMode="Primary">
                    <AboutDocumentDialog documentLoader={documentLoader}/>
                    <span className="dense">Contentum: {documentName}</span>
                    <div className="e-appbar-spacer"></div>
                    { allowEdit && 
                        <ButtonComponent 
                            cssClass='e-inherit login' 
                            iconCss="e-icons e-save" 
                            onClick={() => { saveDocument(documentEditorContainer,documentLoader) }}
                        >
                            <span style={{ color: contentChange ? '#e3165b' : '' }}>Зберегти</span>
                        </ButtonComponent>
                    }
                    { (documentLoader.document.access.allowExport || documentLoader.document.access.allowDownload) &&
                        <ButtonComponent cssClass='e-inherit login' iconCss="e-icons e-print" onClick={() => { documentEditorContainer?.documentEditor.print() }}>Друкувати</ButtonComponent>
                    }
                    { documentLoader.document.access.allowExport &&
                        <ButtonComponent cssClass='e-inherit login' iconCss="e-icons e-export-pdf" onClick={() => { exportDocument2PDF(documentEditorContainer) }}>PDF</ButtonComponent>
                    }
                    { documentLoader.document.access.allowDownload && 
                        <ButtonComponent cssClass='e-inherit login' iconCss="e-icons e-download" onClick={() => { downloadDocument(documentEditorContainer) }}>Завантажити</ButtonComponent>
                    }
                </AppBarComponent>
                </div>
            </div>
            <div id="editorContainerElement">
                <DocumentEditorContainerComponent
                    id="container"
                    ref={(scope: DocumentEditorContainerComponent | null) => { documentEditorContainer = scope; onLoadDefault(); }}
                    style={{ display: "block" }}
                    width={window.innerWidth + 'px'}
                    height={window.innerHeight - 45 + 'px'}
                    serviceUrl={serviceUrl}
                    locale="uk-UA"
                    autoResizeOnVisibilityChange={true}

                    created={() => {
                        if (documentEditorContainer) {
                        // Автоматическая активация контроля изменений
                        documentEditorContainer.documentEditor.enableTrackChanges = true;
                        documentEditorContainer.documentEditor.showRevisions = true;
                        }
                    }}
                    
                    showPropertiesPane={ !allowEdit ? false : true } // if readonly - false, else true or false
                    enableRtl={enableRTL}
                    toolbarItems={
                        !allowEdit ? 
                        [
                        //'New',
                        //'Open',
                        'Separator','Undo','Redo',
                        'Separator','Image','Table','Hyperlink','Bookmark','TableOfContents',
                        'Separator','Header','Footer','PageSetup','PageNumber','Break','InsertFootnote','InsertEndnote',
                        'Separator','Find',
                        'Separator','Comments',
                        //'TrackChanges',
                        'LocalClipboard',
                        //'RestrictEditing',
                        'Separator','FormFields','UpdateFields','ContentControl'
                        ] : [
                        //'New','Open',
                        'Separator','Undo','Redo',
                        'Separator','Image','Table','Hyperlink','Bookmark','TableOfContents',
                        'Separator','Header','Footer','PageSetup','PageNumber','Break','InsertFootnote','InsertEndnote',
                        'Separator','Find',
                        'Separator','Comments',
                        //'TrackChanges',
                        'LocalClipboard',
                        'RestrictEditing',
                        'Separator','FormFields','UpdateFields','ContentControl'
                        ]
                    }
                />
            </div>
            <ToastComponent 
                ref={(toast: any) => toastInstance = toast!} 
                title="На жаль, Ви не можете редагувати документ"
                content={getToastContent()}
                created={toastCreated} 
                showProgressBar={true}
                timeOut={10000}
                position={{ X: 'Right', Y: 'Top' }}
                enableRtl={enableRTL}
            />
            <div className="toastUtility"></div>
        </React.Fragment>
    )

}

export default WordApp;